import { createContext, useContext } from "react";
import ILessonPageDto from "../../models/ILessonPageDto";

export interface ILegacyLessonPageContext {
  lessonPages: ILessonPageDto[];
}

export const LegacyLessonPageContext: React.Context<ILegacyLessonPageContext> = createContext<ILegacyLessonPageContext>(
  {} as ILegacyLessonPageContext,
);

export function useLegacyLessonPages() {
  return useContext(LegacyLessonPageContext);
}
